import { getDataMapper, mapArray, mapField } from "@/shared";

export const mapShiftRowFromServer = getDataMapper({
    id: mapField("id", Number),
    humanId: mapField("human_id", Number),
    humanFio: mapField("human_fio"),
    pointId: mapField("point_id", Number),
    pointTitle: mapField("point_title"),
    timeStart: mapField("time_start"),
    timeEnd: mapField("time_end"),
    period: mapField("period"),
    countClient: mapField("count_client", Number),
    countRent: mapField("count_rent", Number),
    countStock: mapField("count_stock", Number),
    countRepair: mapField("count_repair", Number),
    sumRent: mapField("sum_rent", Number),
    sumStock: mapField("sum_stock", Number),
    sumRepair: mapField("sum_repair", Number),
    sumExpense: mapField("sum_expense", Number),
    sumTotal: mapField("sum_total", Number),
});

export const mapShiftRowsFromServer = mapArray(mapShiftRowFromServer);
